export const apiEndPoints = {
  // --------------------- Login API --------------------- //

  login: 'Account/Login',

  refreshToken: 'Account/GenerateJwtToken',

  // --------------------- Add City API --------------------- //

  addCity: 'BackOffice/AddCity',

  addCityCoordinates: 'BackOffice/AddCitywithCoordinates',

  // --------------------- Edit Coordinates API --------------------- //

  editCoordinates: 'BackOffice/CityCordinateUpdate',

  deleteCity: 'BackOffice/DeleteCity',

  // --------------------- Get City List API --------------------- //

  cityList: 'BackOffice/CityList',

  // --------------------- Active & Inactive City API --------------------- //

  activeInactiveCity: 'BackOffice/CityStatusUpdate',

  // --------------------- Add Zone API --------------------- //

  addZone: 'BackOffice/AddZone',

  // --------------------- Get Zone List API --------------------- //

  zoneList: 'BackOffice/ZoneList',

  // --------------------- Get User Type List API --------------------- //

  userType: 'BackOffice/GetUserTypeList',

  // --------------------- Add Container API --------------------- //

  addContainer: 'BackOffice/AddContainerDetails',

  addSAContainer: 'SuperAdmin/AddContainerDetails',

  // --------------------- Get All Container List API --------------------- //

  containerList: 'BackOffice/GetAllContainerDetails',

  initialContainerList: 'SuperAdmin/GetAllContainerDetails',

  containerListSA: 'SuperAdmin/GetAllContainerDetailsByCityId',

  // --------------------- Get Container Name API --------------------- //

  containerName: 'BackOffice/GetAllContainerName',

  filterContainerName: 'SuperAdmin/GetAllContainerNameByCityId',

  // --------------------- Get Container Capacity List API --------------------- //

  containerCapacityList: 'BackOffice/GetContainerCapacity',

  // --------------------- Add Container Price API --------------------- //

  containerPriceConfigure: 'BackOffice/ContainerPaymentSetting',

  superAdminContainerPriceConfigure: 'SuperAdmin/ContainerPaymentSetting',

  // --------------------- Active & Inactive Zone API --------------------- //

  ZoneStatusUpdate: 'BackOffice/ZoneStatusUpdate',

  // --------------------- Get Container Price List API --------------------- //

  containerPriceList: 'BackOffice/GetContainerPriceDetails',

  superAdminContainerPriceList: 'SuperAdmin/GetContainerPriceDetails',

  // --------------------- Update Container Price List API --------------------- //

  updatePriceList: 'BackOffice/UpdateContainerPayment',

  superAdminUpdatePriceList: 'SuperAdmin/UpdateContainerPayment',

  // --------------------- Get Approve Order List API --------------------- //

  getApproveOrder: 'Requester/GetRequestList',

  // --------------------- Post Approve Order Status API --------------------- //

  orderStatus: 'OrderFlow/OrderReleaseStatusUpdate',

  // --------------------- Get All Users API --------------------- //

  allUsers: 'Account/GetAllUsers',

  // --------------------- Get Release Payment List API --------------------- //

  releasePayment: 'Payment/OrderReleasePayment',

  // --------------------- Get Bank Details API --------------------- //

  getBankDetails: 'BackOffice/GetBankDetailsByOrderId',

  // --------------------- Post Release Payment API --------------------- //

  paymentRelease: 'OrderFlow/PaymentReleaseStatusUpdate',

  // --------------------- Post Approve/Reject User API --------------------- //

  UserApprovalUpdate: 'BackOffice/UserApprovalUpdate',

  // --------------------- Get All Users API --------------------- //

  GetSmsLogDetails: 'BackOffice/GetSmsLogDetails',

  // --------------------- Post UserAccountStatusUpdate (Active/Inactive)API --------------------- //

  UserAccountStatusUpdate: 'Account/UserAccountStatusUpdate',

  // --------------------- Active & Inactive Users API --------------------- //

  activeInactiveUsers: 'Account/UserAccountStatusUpdate',

  // --------------------- Get Registered Dashboard get API --------------------- //

  getDashboardDetails: 'DashBoard/RegisterUser',

  // --------------------- Get Registered Dashboard Filter API --------------------- //

  registeredDashboardFilter: 'DashBoard/RegisterUserFilter',

  // --------------------- Revenue Dashboard API --------------------- //

  revenueDashboardData: 'DashBoard/Revenue',

  // --------------------- MobileUsers Dashboard API --------------------- //

  mobileUsersDashboard: 'DashBoard/MobileUsers',

  // --------------------- Get Order Summary API --------------------- //

  orderSummary: 'Report/OrderSummary',

  // --------------------- Get User Summary API --------------------- //

  userSummary: 'Report/UserSummary',

  // --------------------- Get User Summary List API --------------------- //

  summaryUserList: 'Report/UserListRPT',

  // --------------------- Get User On & Off business API --------------------- //

  onOffBuisness: 'BackOffice/UserOnandOffBussiness',

  // --------------------- Get All Fence API --------------------- //

  allFence: 'SuperAdmin/GetCoordinates',

  // --------------------- User Account Delete --------------------- //

  userDelete: 'Account/UserAccountStatusUpdateByPhoneNo',

  // --------------------- Add Commission --------------------- //

  addCommission: 'Common/addCommissionConfiguration',

  // --------------------- Update Commission --------------------- //

  updateCommission: 'Common/UpdateCommissionConfiguration',

  // --------------------- Get All Commission --------------------- //

  commissionList: 'Common/GetAllCommissionConfiguration',

  // --------------------- Get All Filtered Commission --------------------- //

  filteredCommissionList: 'Common/GetCommissionConfiguration',

  // ---------------------- Get Order Summary by Date API ---------------------- //

  OrderSummaryByDate: 'Report/OrderSummaryReportByCompletionDate',

  // ---------------------- Post City Config API ---------------------- //

  addCityConfig: 'SuperAdmin/AdminConfiguration',

  // ---------------------- Get City Config List API ---------------------- //

  cityConfigList: 'SuperAdmin/GetAdminConfigDetails',

  // ---------------------- Update City Config API ---------------------- //

  updateCityConfig: 'SuperAdmin/AdminConfigurationUpdate',

  // ---------------------- Add Sidemenu API ---------------------- //

  addSideMenu: 'Configuration/AddMainMenu',

  // ---------------------- Get Sidemenu API ---------------------- //

  sideMenuList: 'Configuration/GetMainMenuList',

  // ---------------------- Delete MainMenu API ---------------------- //

  deleteMainMenu: 'Configuration/DeleteMainMenu',

  // ---------------------- Delete SubMenu API ---------------------- //

  deleteSubMenu: 'Configuration/DeleteSubMenu',

  // ---------------------- Update MainMenu API ---------------------- //

  updateMainMenu: 'Configuration/UpdateMainMenu',

  // ---------------------- Add SubMenu API ---------------------- //

  addSubMenu: 'Configuration/AddSubMenu',

  // ---------------------- Get SubMenu List API ---------------------- //

  subMenuList: 'Configuration/GetSubMenuList',

  // ---------------------- Update SubMenu API ---------------------- //

  updateSubMenu: 'Configuration/UpdateSubMenu',

  // ---------------------- Add Menu Configuration API ---------------------- //

  addMenuConfig: 'Configuration/AddMenuMapping',

  // ---------------------- Get Menu Mapping API ---------------------- //

  getMenuMapping: 'Configuration/GetMenuMappingList',

  // ---------------------- Add Menu Configuration API ---------------------- //

  updateMenuConfig: 'Configuration/UpdateMenuMappingList',

  // ---------------------- Baldia Dumpyard List API ---------------------- //

  baldiaDumpyardList: 'BackOffice/BaldiaDumpYardList',

  // ---------------------- Baldia Approve Api ---------------------- //

  baldiaApprove: 'OrderFlow/BaldiaApproval',

  // ---------------------- Baldia Document Download Api ---------------------- //

  baldiaDoc: 'Invoice/EOCDocDownload',

  // --------------------- Get Dumpyard locations --------------------- //

  dumpyardLocation: 'CityBasedBackOffice/GetDumpyardOnGoingOrdersandLocation',

  // --------------------- Get Dumpyard locations --------------------- //

  viewEoc: 'Invoice/EOCDocView',

  // --------------------- Get Baldia dashboard --------------------- //

  baldiaUserDashboard: 'DashBoard/BaldiaDashBoard',

  // --------------------- Get Dumpster Location --------------------- //

  dumpsterLocation: 'Requester/GetContainerDetailsByUserId',

  // --------------------- Post Push notification --------------------- //

  createPushNotification: 'Notification/CreatePushNotification',

  updatePushNotification: 'Notification/UpdatePushNotification',

  deleteNotification: 'Notification/DeletePushNotification',

  notificationList: 'Notification/GetPushNotification',

  // --------------------- Push notification list --------------------- //

  salesDashboardData: 'DashBoard/Sales',

  orderTimeLineData: 'Report/OrderTimeLineRPT',

  downloadInitialRequestorInvoice: 'Invoice/InitialRequestorInvoice',

  notification: 'Notification/GetOrderNotification',

  downloadDumpyardInvoice: 'Invoice/DumpyardInvoice',

  downloadDumpsterInvoice: 'Invoice/DumpsterInvoice',

  downloadRequestorRefundInvoice: 'Invoice/RequestorRefundInvoice',

  crVatDownload: 'Invoice/CRVATDownload',

  containerDetails: 'Account/GetUserById',
};
